import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withTheme from '@mui/styles/withTheme';
// import transitions from 'material-ui/styles/transitions';
import FormLabel from '@mui/material/FormLabel';

const getStyles = (props, theme, state) => {
  const styles = {
    root: {
      fontSize: 16,
      lineHeight: '24px',
      width: props.fullWidth
        ? '100%'
        : 256,
      height: props.floatingLabelText
        ? 72
        : 48,
      marginTop: 15,
      display: 'inline-block',
      position: 'relative',
      // backgroundColor: theme.palette.background.default,
      fontFamily: theme.typography.fontFamily,
      // transition: transitions.easeOut('200ms', 'height'),
      cursor: props.disabled
        ? 'not-allowed'
        : 'auto',
    },
    error: {
      position: 'relative',
      bottom: 2,
      fontSize: 12,
      lineHeight: '12px',
      color: theme.palette.error.main,
      // transition: transitions.easeOut(),
    },
    floatingLabel: {
      // color: props.disabled
      //   ? theme.palette.text.disabled
      //   : theme.palette.text.primary,
      pointerEvents: 'none',
    },
  };

  if (state.isFocused) {
    styles.floatingLabel.color = state.errorText
      ? styles.error.color
      : theme.palette.action.focus;
  }

  if (props.floatingLabelText && state.errorText) {
    styles.error.bottom = styles.error.fontSize + 3;
  }

  return styles;
};

class Field extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    errorStyle: PropTypes.object,
    errorText: PropTypes.node,
    floatingLabelFixed: PropTypes.bool,
    floatingLabelFocusStyle: PropTypes.object,
    floatingLabelShrinkStyle: PropTypes.object,
    floatingLabelStyle: PropTypes.object,
    floatingLabelText: PropTypes.node,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    style: PropTypes.object,
    required: PropTypes.bool,
    theme: PropTypes.object.isRequired,
  };

  state = {
    isFocused: false,
    errorText: undefined,
    hasValue: false,
  };

  blur = () => this.setState({
    isFocused: false,
  });

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    const { disabled, errorText } = this.props;
    if (nextProps.disabled && !disabled) {
      this.setState({
        isFocused: false,
      });
    }

    if (nextProps.errorText !== errorText) {
      this.setState({
        errorText: nextProps.errorText,
      });
    }
  }

  focus = () => {
    const { disabled } = this.props;
    if (disabled) {
      return;
    }
    this.setState({
      isFocused: true,
    });
  };

  render() {
    const {
      children,
      disabled,
      errorStyle,
      errorText,
      floatingLabelFixed,
      floatingLabelFocusStyle,
      floatingLabelShrinkStyle,
      floatingLabelStyle,
      floatingLabelText,
      fullWidth,
      style,
      required,
      ...props
    } = this.props;
    const { isFocused } = this.state;
    const { theme } = this.props;

    const styles = getStyles(this.props, theme, this.state);

    return (
      <div
        {...props}
        style={Object.assign(styles.root, style)}
      >
        {floatingLabelText && (
          <FormLabel
            required
            style={Object.assign(
              styles.floatingLabel,
              floatingLabelStyle,
              isFocused
                ? floatingLabelFocusStyle
                : null,
            )}
            shrinkStyle={floatingLabelShrinkStyle}
            shrink={isFocused || floatingLabelFixed}
            disabled={disabled}
          >
            {floatingLabelText}
          </FormLabel>
        )}
        {children}
        {errorText && (
          <div style={Object.assign(styles.error, errorStyle)}>
            {errorText}
          </div>
        )}
      </div>
    );
  }
}

export default withTheme(Field);
